export enum Breakpoint {
  MobileSmall = '450px',
  Mobile = '576px',
  Tablet = '768px',
  Desktop = '992px',
  LargeDesktop = '1200px',
  MaxContent = '1440px',
}
